module.exports = __webpack_public_path__ + "img/13.da0db78b.svg";